import CloseIcon from '../../../assets/icons/close.svg?react';
import { useDeleteContact } from '../../../hooks/queries/smsQueries';
import { useState } from 'react';
const SmsContactDeleteModal = ({ onClose, onDeleteSuccess, contact }) => {
  const deleteContact = useDeleteContact();
  const [isPending, setIsPending] = useState(false);
  const handleDelete = async () => {
    try {
      setIsPending(true);
      await deleteContact.mutateAsync({
        name: contact.Name,
        phoneNumber: contact.PhoneNumber,
        organization: contact.Organization,
      });
      onDeleteSuccess();
      onClose();
    } catch (error) {
      console.error('연락처 삭제 실패:', error);
      alert('연락처 삭제에 실패했습니다.');
      onClose();
    }
    finally {
      setIsPending(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>연락처 삭제</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-body">
          <p className="text-b2-400 text-gray-700 mb-20">
            <strong>{contact?.Name}</strong>님의 연락처를 삭제하시겠습니까?
          </p>
        </div>
        <div className="modal-footer flex gap-10">
          <button className="btn big-btn btn-style-5" onClick={onClose} disabled={isPending}>
            {'취소'}
          </button>
          <button className="btn big-btn btn-danger" onClick={handleDelete} disabled={isPending}>
            {isPending ? '삭제 중...' : '삭제'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SmsContactDeleteModal;
